/**
 * Shared grid template for drafts list header and rows.
 * Ensures columns align when values are missing.
 * For Media Devoted | Created By Ciro Autiero
 */

/**
 * Grid template for row (no drag). Matches ListHeader columns:
 * Gateway, Creative, Leads, Campaign, Cost, Amount, Total cost, TLD, Static Tag,
 * Planned send (DK), Local send (country tz), Created/time, Status, Actions.
 */
export const DRAFTS_ROW_GRID =
  'minmax(180px,1fr) minmax(60px,180px) minmax(260px,1fr) 90px 52px 48px 64px 80px 90px minmax(96px,112px) minmax(84px,104px) 100px minmax(0,1fr) 72px';

const COUNTRY_COL = 'minmax(72px, 96px)';

/** Country column prepended (pinned multi-country view). */
export const DRAFTS_ROW_GRID_WITH_COUNTRY = `${COUNTRY_COL} ${DRAFTS_ROW_GRID}`;

/** Grid template when drag handle column is present. */
export const DRAFTS_ROW_GRID_WITH_DRAG = `40px ${DRAFTS_ROW_GRID}`;

export const DRAFTS_ROW_GRID_WITH_DRAG_AND_COUNTRY = `40px ${DRAFTS_ROW_GRID_WITH_COUNTRY}`;

/** Tailwind-compatible style for row grid. */
export const draftsRowGridStyle = {
  gridTemplateColumns: DRAFTS_ROW_GRID,
} as const;

export const draftsRowGridWithCountryStyle = {
  gridTemplateColumns: DRAFTS_ROW_GRID_WITH_COUNTRY,
} as const;

/** Tailwind-compatible style for header grid with drag. */
export const draftsHeaderGridWithDragStyle = {
  gridTemplateColumns: DRAFTS_ROW_GRID_WITH_DRAG,
} as const;

export const draftsHeaderGridWithDragAndCountryStyle = {
  gridTemplateColumns: DRAFTS_ROW_GRID_WITH_DRAG_AND_COUNTRY,
} as const;

/** Tailwind-compatible style for header grid without drag. */
export const draftsHeaderGridStyle = {
  gridTemplateColumns: DRAFTS_ROW_GRID,
} as const;

export const draftsHeaderGridWithCountryStyle = {
  gridTemplateColumns: DRAFTS_ROW_GRID_WITH_COUNTRY,
} as const;

/** Subgrid style so header/rows inherit parent column structure for perfect alignment. */
export const draftsSubgridRowStyle = {
  gridColumn: '1 / -1',
  display: 'grid',
  gridTemplateColumns: 'subgrid',
} as const;
